document.addEventListener('change', event => {
  if (event.target.id !== 'variant-select') return;
  const select = event.target;
  const option = select.selectedOptions[0];
  if (!option) return;
  document.getElementById('variant-price').textContent = option.dataset.price;
  const button = document.getElementById('add-button');
  const available = option.dataset.available === 'true';
  button.disabled = !available;
  button.textContent = available ? button.dataset.add : button.dataset.sold;
  const url = new URL(window.location.href);
  url.searchParams.set('variant', select.value);
  window.history.replaceState({}, '', url);
});

document.querySelectorAll('[data-arcade-section]').forEach(section => {
  const dialog = section.querySelector('[data-game-dialog]');
  const board = section.querySelector('[data-board]');
  const target = section.querySelector('[data-target]');
  const message = section.querySelector('[data-message]');
  const scoreEl = section.querySelector('[data-score]');
  const timerEl = section.querySelector('[data-timer]');
  const reward = section.querySelector('[data-reward]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let score = 0;
  let seconds = 20;
  let timer = 0;
  let directionTimer = 0;
  let animationFrame = 0;
  let lastFrame = 0;
  let x = 0;
  let y = 0;
  let velocityX = 0;
  let velocityY = 0;
  let speed = 330;
  let running = false;

  const targetSize = () => target.offsetWidth || 78;
  const limits = () => ({
    x: Math.max(0, board.clientWidth - targetSize()),
    y: Math.max(0, board.clientHeight - targetSize())
  });

  const setPosition = () => {
    target.style.setProperty('--target-x', `${x}px`);
    target.style.setProperty('--target-y', `${y}px`);
  };

  const setDirection = () => {
    const angle = Math.random() * Math.PI * 2;
    const activeSpeed = reducedMotion.matches ? 170 : speed;
    velocityX = Math.cos(angle) * activeSpeed;
    velocityY = Math.sin(angle) * activeSpeed;
  };

  const relocate = () => {
    const max = limits();
    target.classList.add('relocating');
    x = Math.random() * max.x;
    y = Math.random() * max.y;
    setDirection();
    setPosition();
    window.setTimeout(() => target.classList.remove('relocating'), 90);
  };

  const animate = timestamp => {
    if (!running) return;
    if (!lastFrame) lastFrame = timestamp;
    const elapsed = Math.min((timestamp - lastFrame) / 1000, 0.034);
    lastFrame = timestamp;
    const max = limits();
    x += velocityX * elapsed;
    y += velocityY * elapsed;
    if (x <= 0 || x >= max.x) {
      x = Math.min(Math.max(x, 0), max.x);
      velocityX *= -1;
    }
    if (y <= 0 || y >= max.y) {
      y = Math.min(Math.max(y, 0), max.y);
      velocityY *= -1;
    }
    setPosition();
    animationFrame = window.requestAnimationFrame(animate);
  };

  const stop = () => {
    running = false;
    window.clearInterval(timer);
    window.clearInterval(directionTimer);
    window.cancelAnimationFrame(animationFrame);
    lastFrame = 0;
  };

  const finish = () => {
    stop();
    target.style.display = 'none';
    message.style.display = 'grid';
    message.innerHTML = `<div class="eyebrow">ROUND COMPLETE</div><h2>${score} points.</h2><p>${score >= 500 ? '$5 reward unlocked.' : 'Five hits unlock the reward. Run it back.'}</p><button type="button" class="arcade-launch" data-restart>PLAY AGAIN</button>`;
    message.querySelector('[data-restart]').addEventListener('click', start);
    if (score >= 500) reward.hidden = false;
  };

  const start = () => {
    stop();
    score = 0;
    seconds = 20;
    speed = board.clientWidth < 560 ? 285 : 330;
    scoreEl.textContent = '0';
    timerEl.textContent = 'TIME 20';
    reward.hidden = true;
    message.style.display = 'none';
    target.style.display = 'block';
    running = true;
    relocate();
    animationFrame = window.requestAnimationFrame(animate);
    directionTimer = window.setInterval(setDirection, 420);
    timer = window.setInterval(() => {
      seconds -= 1;
      timerEl.textContent = `TIME ${seconds}`;
      if (seconds <= 0) finish();
    }, 1000);
  };

  section.querySelector('[data-start]').addEventListener('click', start);
  target.addEventListener('click', () => {
    if (!running) return;
    score += 100;
    speed = Math.min(speed + 55, 660);
    scoreEl.textContent = String(score);
    if (score >= 500) {
      finish();
      return;
    }
    relocate();
  });
  section.querySelector('[data-open-game]').addEventListener('click', () => dialog.showModal());
  section.querySelector('[data-close-game]').addEventListener('click', () => {
    stop();
    target.classList.remove('relocating');
    dialog.close();
  });
  dialog.addEventListener('cancel', stop);
  window.addEventListener('resize', () => {
    const max = limits();
    x = Math.min(x, max.x);
    y = Math.min(y, max.y);
    setPosition();
  });

  const spin = section.querySelector('[data-spin]');
  spin.addEventListener('click', () => {
    const reels = section.querySelector('[data-reels]');
    reels.classList.remove('spin-pop');
    void reels.offsetWidth;
    reels.classList.add('spin-pop');
    if (reels.firstElementChild) reels.append(reels.firstElementChild);
  });
});
